import { NgModule } from '@angular/core';
import { LIB_CommonModule } from 'pbc.angular';
import { PostKonstanteCommandService } from '.';

@NgModule({
  imports: [
    LIB_CommonModule,
  ],
  providers: [PostKonstanteCommandService],
  exports: []
})
export class PostKonstanteCommandServiceModule { }
